import { render, staticRenderFns } from "./hh1.vue?vue&type=template&id=12c2e480&scoped=true"
import script from "./hh1.vue?vue&type=script&lang=js"
export * from "./hh1.vue?vue&type=script&lang=js"
import style0 from "./hh1.vue?vue&type=style&index=0&id=12c2e480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2e480",
  null
  
)

export default component.exports